export default "__VITE_ASSET__rM9ZGrGS__"